import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Regex } from '@shared/enums/regex';

export function noIllegalCharactersValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const illegalCharacterRegex = new RegExp(Regex.IllegalCharacter);
    const match = illegalCharacterRegex.test(control.value);

    if (match) {
      return { illegalCharacter: true };
    }

    return null;
  };
}
